import React, {useEffect, useState} from 'react';
import { useOutletContext } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import LookupDropdown from '../components/LookupDropdown';
import {Endpoints} from "../constants/env/middletier";

import { Badge } from 'primereact/badge';


export default function SamplePage() {
    const { lookups } = useOutletContext();

    const [discipline, setDiscipline] = useState({});
    const [status, setStatus] = useState({});
    const [cxtype, setCxType] = useState({});
    const [timezone, setTimezone] = useState({});

    const [project, setProject] = useState({
        id: 1,
        name: 'Cx Building Project 1',
        number: '54015.1',
        clientName: 'ACME industries building division',
        clientRef: 'ref1',
        clientId: -1,
        status: 'In Progress',
        issueStatus: 'In Progress',
        cxType: 'New Building Commission',
        cxTasks: 'task1',
        grossSquareFootage: '10000',
        timezone: 'eastern',
        startDate: new Date('2015-08-15'),
        anticipatedCompletionDate: new Date('2025-08-15'),
        notes: 'This project is for testing purposes only',
        discipline: ''
    });

    const updateField = (field, value) => {
        setProject((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...project,
            startDate: project.startDate?.toISOString().split('T')[0],
            anticipatedCompletionDate:
                project.anticipatedCompletionDate
                    ?.toISOString()
                    .split('T')[0]
        };

        console.log('Saving project:', payload);
        console.log('disciplines obj:', lookups.disciplines);
        console.log('disciplines label:', lookups.disciplines[project.discipline - 1].label);

        // TODO: Call your API here
    };

    return (
        <>
            <br />
            <br />
            <br />

            <div className="card flex justify-content-center">
                {project.discipline && <Badge value={project.discipline}></Badge>}
                {project.discipline && <Badge value={lookups.disciplines[project.discipline - 1].label}></Badge>}
            </div>

            <div className="flex justify-content-center p-4">
                <Card title="Component View" className="w-full lg:w-8">
                    <form onSubmit={handleSubmit}>
                        <div className="grid formgrid p-fluid">

                            <div className="field col-12 md:col-6">
                                <label htmlFor="status">Status</label>
                                <Dropdown
                                    id="status"
                                    value={project.status}
                                    options={lookups.statusLookups}
                                    optionLabel="label"
                                    optionValue="id"
                                    onChange={(e) => updateField('status', e.value)}
                                    placeholder="Select Status"
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="issue_status">Issue Status</label>
                                <Dropdown
                                    id="issue_status"
                                    value={project.issueStatus}
                                    options={lookups.issueStatusLookups}
                                    optionLabel="label"
                                    optionValue="id"
                                    onChange={(e) => updateField('issueStatus', e.value)}
                                    placeholder="Select Status"
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="cxType">Commissioning Type</label>
                                <Dropdown
                                    id="cxType"
                                    value={project.cxType}
                                    options={lookups.cxTypeLookups}
                                    optionLabel="label"
                                    optionValue="id"
                                    onChange={(e) => updateField('cxType', e.value)}
                                    placeholder="Select Type"
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="timezone">Timezone</label>
                                <Dropdown
                                    id="timezone"
                                    value={project.timezone}
                                    options={lookups.timezoneLookups}
                                    optionLabel="label"
                                    optionValue="id"
                                    onChange={(e) => updateField('timezone', e.value)}
                                    placeholder="Select Timezone"
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="timezone">Discipline</label>
                                <Dropdown
                                    id="timezone"
                                    value={project.discipline}
                                    options={lookups.disciplines}
                                    optionLabel="label"
                                    optionValue="id"
                                    onChange={(e) => updateField('discipline', e.value)}
                                    placeholder="Select Discipline"
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="timezone">Client</label>
                                <Dropdown
                                    id="timezone"
                                    value={project.clientId}
                                    options={lookups.clientLookups}
                                    optionLabel="label"
                                    optionValue="id"
                                    onChange={(e) => updateField('clientId', e.value)}
                                    placeholder="Select Client"
                                />
                            </div>




                            <div className="field col-12 md:col-6">
                                <label htmlFor="name">Project Name</label>
                                <InputText
                                    id="name"
                                    value={project.name}
                                    onChange={(e) => updateField('name', e.target.value)}
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="number">Project Number</label>
                                <InputText
                                    id="number"
                                    value={project.number}
                                    onChange={(e) => updateField('number', e.target.value)}
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="clientName">Client Name</label>
                                <InputText
                                    id="clientName"
                                    value={project.clientName}
                                    onChange={(e) => updateField('clientName', e.target.value)}
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="clientRef">Client Reference</label>
                                <InputText
                                    id="clientRef"
                                    value={project.clientRef}
                                    onChange={(e) => updateField('clientRef', e.target.value)}
                                />
                            </div>



                            <div className="field col-12">
                                <label htmlFor="cxTasks">Commissioning Tasks</label>
                                <InputTextarea
                                    id="cxTasks"
                                    rows={3}
                                    value={project.cxTasks}
                                    onChange={(e) => updateField('cxTasks', e.target.value)}
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="grossSquareFootage">
                                    Gross Square Footage
                                </label>
                                <InputText
                                    id="grossSquareFootage"
                                    value={project.grossSquareFootage}
                                    onChange={(e) =>
                                        updateField(
                                            'grossSquareFootage',
                                            e.target.value
                                        )
                                    }
                                />
                            </div>


                            <div className="field col-12 md:col-6">
                                <label htmlFor="startDate">Start Date</label>
                                <Calendar
                                    id="startDate"
                                    value={project.startDate}
                                    onChange={(e) =>
                                        updateField('startDate', e.value)
                                    }
                                    showIcon
                                    dateFormat="yy-mm-dd"
                                />
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="anticipatedCompletionDate">
                                    Anticipated Completion Date
                                </label>
                                <Calendar
                                    id="anticipatedCompletionDate"
                                    value={project.anticipatedCompletionDate}
                                    onChange={(e) =>
                                        updateField(
                                            'anticipatedCompletionDate',
                                            e.value
                                        )
                                    }
                                    showIcon
                                    dateFormat="yy-mm-dd"
                                />
                            </div>

                            <div className="field col-12">
                                <label htmlFor="notes">Notes</label>
                                <InputTextarea
                                    id="notes"
                                    rows={5}
                                    value={project.notes}
                                    onChange={(e) => updateField('notes', e.target.value)}
                                />
                            </div>

                            <div className="col-12 flex justify-content-end">
                                <Button
                                    type="submit"
                                    label="Save Project"
                                    icon="pi pi-save"
                                />
                            </div>
                        </div>
                    </form>
                </Card>
            </div>
        </>

    );
}